import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { getGlobalConfig } from 'gf-ui';

const Root = () => {
    const [config, setConfig] = useState(null);
    const [configError, setConfigError] = useState(false);

    useEffect(() => {
        async function load() {
            try{
                const _config = await getGlobalConfig();
                if(!_config){
                    setConfigError(true);
                    return;
                }
                setConfig(_config);
            }catch(error){
                setConfigError(true);
            }finally{                                        
                const preloader = document.getElementById('__preloader__');
                if (preloader) preloader.style.display = 'none';            
            }
        }

        load();
    }, []);

    return config && window?.globalConfig ?       
        <React.StrictMode>
            <App />
        </React.StrictMode>        
        :
        configError && (
            <div className="wv-100 vh-100 d-flex flex-column justify-content-center align-items-center">
                <div className='text-center bg-white p-4 rounded shadow'>
                    <p className='fw-bold text-primary'>Errore di configurazione</p>
                    <p>Contattare l'amministratore del sistema.</p>
                </div>
            </div>
        )
        ;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);